import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Normalise stored media URLs so they always resolve on the current origin.
// Uploaded media URLs used to be saved with the preview subdomain hardcoded
// (e.g. https://as-design-portal.preview.emergentagent.com/api/media/...).
// When the site is served from a different domain (production), those
// absolute URLs can be blocked or slower. This helper extracts the
// /api/media/... path so the browser resolves relative to the current host.
export function mediaUrl(url) {
  if (!url) return "";
  const marker = "/api/media/";
  const idx = url.indexOf(marker);
  if (idx >= 0) return url.slice(idx); // returns "/api/media/..."
  return url; // external URL (Unsplash / Pexels / customer-assets) — leave as-is
}

// Ensure every request carries cookies + a Bearer header when a token is cached
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("as_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
